import React, {createContext, useState} from "react";
import PMSPrescriptionTemplateServices from "../../services/pms_services/PMSPrescriptionTemplateServices";
import Notification from "../../components/common/Notification";

export const PMSPrescriptionTemplateContext = createContext("PMSPrescriptionTemplateContext");

const PMSPrescriptionTemplateContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [totalElements, setTotalElements] = useState(0);
    const [templates, setTemplates] = useState([]);
    const [template, setTemplate] = useState(null);

    const handleError = (error) => {
        setLoading(false);
        let _error = "Something went wrong.";
        if (error.message === "Network Error") _error = error.message;
        if (error.response && error.response.data) _error = error.response.data.message;
        setErrorMsg(_error);
        Notification("error", "ERROR", `${_error}`);
        return false;
    };

    const getAllTemplatesByPharmacyId = async (pharmacyId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSPrescriptionTemplateServices.getAllTemplatesByPharmacyId(pharmacyId, params);
            setTemplates(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const getTemplateById = async (pharmacyId, id) => {
        try {
            setLoading(true);
            setTemplate(null);
            setErrorMsg("");
            const res = await PMSPrescriptionTemplateServices.getTemplateById(pharmacyId, id);
            setTemplate(res.data);
            setLoading(false);
            return res.data;
        } catch (error) {
            return handleError(error);
        }
    };

    const createTemplate = async (pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSPrescriptionTemplateServices.createTemplate(pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Prescription template created successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const updateTemplateById = async (pharmacyId, id, data) => {
        try {
            setLoading(true);
            await PMSPrescriptionTemplateServices.updateTemplateById(pharmacyId, id, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Prescription template updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const clearTemplate = () => setTemplate(null);

    const deleteTemplateById = async (pharmacyId, id) => {
        try {
            setLoading(true);
            await PMSPrescriptionTemplateServices.deleteTemplateById(pharmacyId, id);
            setLoading(false);
            Notification("success", "SUCCESS", "Prescription template deleted successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    return (
        <PMSPrescriptionTemplateContext.Provider
            value={{
                loading,
                errorMsg,
                totalElements,
                templates,
                template,
                getAllTemplatesByPharmacyId,
                getTemplateById,
                clearTemplate,
                createTemplate,
                updateTemplateById,
                deleteTemplateById,
            }}
        >
            {children}
        </PMSPrescriptionTemplateContext.Provider>
    );
};

export default PMSPrescriptionTemplateContextProvider;
